import {IEntity} from "./IEntity";
import {EmptyGuid} from "../utils/globalVariables";

export interface IOfficeAddRequest extends IEntity {
    OfficeNo: string;
    Country: string;
    City: string;
    DetailedAddress: string;
    PoBox: string;
    Telephone: string;
    IsMainOffice: boolean;
}

export const OfficeAddRequest: IOfficeAddRequest = {
    Id: EmptyGuid,
    OfficeNo: '',
    Country: '',
    City: '',
    DetailedAddress: '',
    PoBox: '',
    Telephone: '',
    IsMainOffice: false,
}